var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_66_655",
    transform: "translate(0 0.166667) scale(0.0333333 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_66_655",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABXUlEQVRIie3Wvy4EURTH8Q9ahUaBJVQeQSmiEn+fggjWKyi1OkIUSipCvIKodIhEJFS6XY0EoZgdljBz7+xGFH7JKWZy7v3ec+bcM4d//ZJaInz7MI1x9KNUe3+HGxxiH7fNOlwPNvCM1xx7wW7tYA1pBg8BwK9WxVRR6LIkglhoffTlWOhMg9B6eHDkJcXSm5X27hDwdhOhqW3mQfvkV++IpHJjwM8+rt+3KgdskmoIJxHwhSzwcQQY2jCL+4B1R1ngq0hwqnas4DFj3UUWuFoQnGoQpz+sq9Y7tuZsVEQx/f9dl4pF3IFV2ak+zwIXKa45TSiuxQjwMM4C/FObzwL3ym8go9iLAL7iSU4Dga3ITUNsPQ9K8uMPuVahVkFXCBjGhE0cefaCyVBoqrLGB4GlWGiqKcXSXsFEUWiqTqxJKjMkyh0B3zSmvZV8jLcDPo+315IGcVB7/tff0Rt5GX/YWOL4VQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.73f24d0e8d353793f1741a32debcf8b4.svg";
export { ForwardRef as ReactComponent };